// extracted by mini-css-extract-plugin
export var container = "_7b-0";
export var infoButton = "_7b-1";
export var label = "_7b-3";
export var labelExpanded = "_7b-4";
export var price = "_7b-5";
export var priceExpanded = "_7b-6";
export var title = "_7b-2";